document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('.js-contact-form');
  var msgEl = form.querySelector('.js-contact-message');
  var phoneInput = document.querySelector('.js-contact-phone');
  var toggle = document.querySelector('.js-prefix-toggle');
  var dropdown = document.querySelector('.js-prefix-dropdown');
  var toggleFlag = toggle.querySelector('.js-prefix-flag');
  var toggleCountry = toggle.querySelector('.js-prefix-country');
  var isUK = window.location.hostname === 'uk.ivelok.com';
  var KLAVIYO_LIST_ID = isUK ? 'Xdr7wW' : 'XhJmZa';
  var KLAVIYO_API_KEY = isUK ? 'SMdThC' : 'UWdRKm';

  // Full country list — flag CDN + dial code
  var countries = [
    { code: 'AT', name: 'Austria', dial: '+43' },
    { code: 'BE', name: 'Belgium', dial: '+32' },
    { code: 'CA', name: 'Canada', dial: '+1' },
    { code: 'CH', name: 'Switzerland', dial: '+41' },
    { code: 'CZ', name: 'Czech Republic', dial: '+420' },
    { code: 'DE', name: 'Germany', dial: '+49' },
    { code: 'DK', name: 'Denmark', dial: '+45' },
    { code: 'ES', name: 'Spain', dial: '+34' },
    { code: 'FI', name: 'Finland', dial: '+358' },
    { code: 'FR', name: 'France', dial: '+33' },
    { code: 'GB', name: 'United Kingdom', dial: '+44' },
    { code: 'GR', name: 'Greece', dial: '+30' },
    { code: 'IT', name: 'Italy', dial: '+39' },
    { code: 'MX', name: 'Mexico', dial: '+52' },
    { code: 'NL', name: 'Netherlands', dial: '+31' },
    { code: 'NO', name: 'Norway', dial: '+47' },
    { code: 'PL', name: 'Poland', dial: '+48' },
    { code: 'PT', name: 'Portugal', dial: '+351' },
    { code: 'RU', name: 'Russia', dial: '+7' },
    { code: 'SE', name: 'Sweden', dial: '+46' },
    { code: 'TR', name: 'Turkey', dial: '+90' },
    { code: 'US', name: 'United States', dial: '+1' },
  ];

  var selectedDial = '';
  var defaultCountry = 'DE';

  // Helper: get flag URL from Shopify CDN
  function flagUrl(code) {
    return 'https://cdn.shopify.com/static/images/flags/' + code.toLowerCase() + '.svg?width=32';
  }

  // Update the toggle button display
  function updateToggle(country) {
    toggleFlag.src = flagUrl(country.code);
    toggleFlag.alt = country.name + ' national flag';
    toggleCountry.textContent = country.dial;
    selectedDial = country.dial;
  }

  // Build dropdown list
  function buildDropdown() {
    var html = '';
    for (var i = 0; i < countries.length; i++) {
      var c = countries[i];
      html +=
        '<button type="button" class="phone-prefix-option js-prefix-option" data-index="' +
        i +
        '">' +
        '<img class="object-contain" src="' +
        flagUrl(c.code) +
        '" alt="' +
        c.code +
        '" width="24" height="24">' +
        '<span class="phone-prefix-option-name">' +
        c.name +
        '</span>' +
        '<span class="phone-prefix-option-code">' +
        c.code +
        '</span>' +
        '<span class="phone-prefix-option-dial">' +
        c.dial +
        '</span>' +
        '</button>';
    }
    dropdown.innerHTML = html;
  }

  // Set default country from IP, fallback DE
  function detectCountry() {
    fetch('https://ipapi.co/json/')
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        var found = false;
        for (var i = 0; i < countries.length; i++) {
          if (countries[i].code === d.country_code) {
            defaultCountry = d.country_code;
            updateToggle(countries[i]);
            found = true;
            break;
          }
        }
        if (!found) {
          setFallback();
        }
      })
      .catch(function () {
        setFallback();
      });
  }

  function setFallback() {
    // Try browser locale
    var lang = (navigator.language || '').split('-');
    if (lang[1]) {
      var code = lang[1].toUpperCase();
      for (var i = 0; i < countries.length; i++) {
        if (countries[i].code === code) {
          defaultCountry = code;
          updateToggle(countries[i]);
          return;
        }
      }
    }
    // Ultimate fallback DE
    updateToggle({ code: 'DE', dial: '+49' });
  }

  // Toggle dropdown
  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    var isOpen = dropdown.style.display === 'block';
    dropdown.style.display = isOpen ? 'none' : 'block';
    toggle.classList.toggle('phone-prefix-toggle--open', !isOpen);
  });

  // Select country
  dropdown.addEventListener('click', function (e) {
    var opt = e.target.closest('.js-prefix-option');
    if (!opt) return;
    var i = parseInt(opt.getAttribute('data-index'), 10);
    if (isNaN(i) || !countries[i]) return;
    updateToggle(countries[i]);
    dropdown.style.display = 'none';
    toggle.classList.remove('phone-prefix-toggle--open');
    // Dial code is shown in the toggle, not in the input
  });

  // Close dropdown on outside click
  document.addEventListener('click', function () {
    dropdown.style.display = 'none';
    toggle.classList.remove('phone-prefix-toggle--open');
  });

  // Init: set default immediately, refine via IP
  buildDropdown();
  // Set initial default (DE) right away
  for (var j = 0; j < countries.length; j++) {
    if (countries[j].code === defaultCountry) {
      updateToggle(countries[j]);
      break;
    }
  }
  detectCountry();

  // Form submit
  var btn = form.querySelector('.js-contact-submit');
  var btnOriginalText = btn.textContent;

  var MAX_SUBMITS = 3;
  var COOLDOWN_MS = 3 * 60 * 1000;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var now = Date.now();
    var firstTime = parseInt(localStorage.getItem('ive_first_submit') || '0', 10);
    var count = parseInt(localStorage.getItem('ive_submit_count') || '0', 10);

    if (firstTime && now - firstTime > COOLDOWN_MS) {
      count = 0;
      localStorage.removeItem('ive_first_submit');
    }

    if (count >= MAX_SUBMITS) {
      msgEl.textContent = 'You have reached the submission limit. Please try again later.';
      msgEl.style.color = 'var(--brandmaincolor)';
      msgEl.style.display = 'block';
      return;
    }

    btn.disabled = true;
    btn.classList.add('is-loading');
    msgEl.style.display = 'none';

    var email = document.querySelector('.js-contact-email').value.trim();
    var phone = phoneInput.value.trim();

    var smsConsent = document.getElementById('contactSmsConsent');
    var hasSms = smsConsent && smsConsent.checked;

    /* Build Klaviyo v3 client subscription payload */
    var profileAttrs = { email: email };
    if (phone) {
      profileAttrs.phone_number = selectedDial + phone.replace(/\s+/g, '');
    }

    // 显式声明 email 订阅 + 可选的 SMS 订阅
    var subscriptions = {
      email: { marketing: { consent: 'SUBSCRIBED' } }
    };
    if (hasSms && phone) {
      subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    profileAttrs.subscriptions = subscriptions;

    // 附加 UTM 参数到 Klaviyo profile 自定义属性（包在 properties 内）
    var utm = window.iveUtm || {};
    var hasUtm = utm.utm_source || utm.utm_medium || utm.utm_campaign || utm.utm_content || utm.utm_term;
    if (hasUtm) {
      profileAttrs.properties = {
        utm_source: utm.utm_source || '',
        utm_medium: utm.utm_medium || '',
        utm_campaign: utm.utm_campaign || '',
        utm_content: utm.utm_content || '',
        utm_term: utm.utm_term || ''
      };
    }

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttrs
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: KLAVIYO_LIST_ID
            }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_API_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2026-04-15'
      },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        if (res.ok) {
          msgEl.textContent = form.dataset.success;
          msgEl.style.color = 'var(--brandmaincolor)';
          msgEl.style.display = 'block';
          form.reset();
          if (!firstTime) localStorage.setItem('ive_first_submit', now.toString());
          localStorage.setItem('ive_submit_count', (count + 1).toString());

          /* 飞书订阅通知 */
          (function () {
            try {
              var utm = window.iveUtm || {};
              var utmStr = '';
              if (utm.utm_source) utmStr += 'utm_source=' + utm.utm_source;
              if (utm.utm_medium) utmStr += (utmStr ? ', ' : '') + 'utm_medium=' + utm.utm_medium;
              if (utm.utm_campaign) utmStr += (utmStr ? ', ' : '') + 'utm_campaign=' + utm.utm_campaign;

              var msg = '📧 页脚订阅\n' +
                '邮箱：' + email + '\n' +
                (phone ? '手机：' + selectedDial + phone + '\n' : '') +
                (hasSms ? '短信订阅：是\n' : '') +
                '站点：' + (isUK ? 'UK' : 'EU') + '\n' +
                (utmStr ? 'UTM：' + utmStr + '\n' : '') +
                '时间：' + new Date().toLocaleString() + '\n' +
                '链接：' + window.location.href;

              fetch(window.IVE_FEISHU_HOOK, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  msg_type: 'text',
                  content: { text: msg }
                })
              }).catch(function () {});
            } catch (e) {}
          })();
        } else {
          return res.text().then(function (text) {
            console.error('Klaviyo error:', res.status, text);
            throw new Error('Submission failed');
          });
        }
      })
      .catch(function (err) {
        console.error('Form submission error:', err);
        msgEl.textContent = form.dataset.error;
        msgEl.style.color = 'red';
        msgEl.style.display = 'block';
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });
});
